<template>
  <v-card>
    <div class="d-flex justify-content-between align-items-center mt-3 p-3">
      <div class="title">
        <h1>Penilaian Akademik</h1>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center p-3">
      <b-form>
        <b-form-group label="Pilih Prodi :">
          <Select2 v-model="myValue" :options="prodiOptions"
            :settings="{ settingOption: value, multiple: false, width: '300%' }" @change="myChangeEvent($event)"
            @select="mySelectEvent($event)" />
        </b-form-group>
      </b-form>
      <div class="toolbar">
        <v-btn style="background-color: #3751E4; color: white; height: 33px; width: 200px; z-index: 1;">
          GENERATE NILAI
        </v-btn>
      </div>
    </div>

    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="PenilaianAkademik.search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :headers="PenilaianAkademik.headers" :items="PenilaianAkademik.isi_data"
      :search="PenilaianAkademik.search">

    </v-data-table>

  </v-card>
</template>

<script>
import Select2 from 'v-select2-component';

export default {
  data() {
    return {
      myValue: '',
      prodiOptions: [
        { id: 'a', text: 'DIKREG' },
        { id: 'b', text: 'DIKMATRA' },
        { id: 'c', text: 'SUSJEMESTRA' }
      ],
      PenilaianAkademik: {
        headers: [
          { text: "No", align: "center", value: "no", sortable: false },
          { text: "NRP", align: "center", value: "nrp" },
          { text: "Nama", align: "center", value: "nama" },
          { text: "IPK", align: "center", value: "ipk" },
          { text: "Predikat", align: "center", value: "predikat" }
        ],
        isi_data: [
          {
            no: 1,
            nrp: 17181,
            nama: "ADE TOSHIO FADLY SE",
            ipk: 0,
            predikat: "-"
          },
          {
            no: 2,
            nrp: 17182,
            nama: "AGUNG NUGROHO",
            ipk: 0,
            predikat: "-"
          },
          {
            no: 3,
            nrp: 17183,
            nama: "AGUNG PURNOMO ST CTMP",
            ipk: 0,
            predikat: "-"
          },
          {
            no: 4,
            nrp: 17184,
            nama: "AGUNG SETIYONO SE",
            ipk: 0,
            predikat: "-"
          },
          {
            no: 5,
            nrp: 17185,
            nama: "AGUNG SUSYANTO ST",
            ipk: 0,
            predikat: "-"
          },
          {
            no: 6,
            nrp: 17185,
            nama: "AHMAD SUSILO NURHUDA ST",
            ipk: 0,
            predikat: "-"
          },
          {
            no: 7,
            nrp: 17186,
            nama: "AHMAD SYUKUR ST",
            ipk: 0,
            predikat: "-"
          }
        ]
      }
    };
  },
  components: {
    Select2
  }
}
</script>